<!-- Generator: Adobe Illustrator 25.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 296.6 219"
  style="enable-background: new 0 0 296.6 219"
  xml:space="preserve"
>
  <path
    class="st0"
    d="M111.9,76.4c-1.8-6.6-1.5-13.6,1-19.9C77,57.3,66.8,21.7,38.1,34.1c-15.9,6.9-23.2,24.4-25.4,32
	c-0.4,1.6,0.5,3.2,2.1,3.7c0.5,0.1,1,0.1,1.5,0c4.8-0.8,9.6-1.3,14.4-1.4c1.1,0,0.7,0.9,0.1,2.4C23.3,90,7.9,94.5,6.5,118.4
	c-1.9,32.2,15.5,50.1,31.8,62.1c1.7,1.2,4.3,1.5,5.4-0.2c31.7-49.9,59-45.4,78.2-60.1C119.8,105.4,116.1,92.2,111.9,76.4z"
  />
  <path
    class="st1"
    d="M126.2,73.7c-9.4,18.8-29.8,45-57.4,57.4c-18.4,8.3-23.8,15.6-32.3,23c-10.3,8.9-13.3,10.9-18.6-1.2
	c-9.6-21.8-5.2-44,6.2-55.3c16.7-16.7,47-11.3,52.4-23.9c-11.3-0.4-36.1-3.7-45.1-4.9c-0.1,0.7-0.3,1.3-0.6,1.9
	C23.3,90,7.9,94.5,6.5,118.4c-1.9,32.2,15.5,50.1,31.8,62.1c1.7,1.2,4.3,1.5,5.4-0.2c42.2-66.4,76.4-36.5,94.5-83.6
	C135.9,80.5,131.8,62.5,126.2,73.7z"
  />
  <path
    class="st1"
    d="M40,48.7c22.9,1.5,18.7,8.7,36.4,13.5c12.3,3.5,29.4,0.8,29.4,0.8c-6.8-0.6-13.6-2-20.1-4
	c-9.6-3.2-13.8-5.9-24.2-11.3S38.5,48.6,40,48.7z"
  />
  <path
    class="st1"
    d="M27.6,142.7c11.1-14.9,16.2-8.7,26.6-14.1c17.5-9,23.1-13.6,33.7-28.2c-10.7,10.5-17.9,10.8-38.7,17.8
	C34,123.3,24.2,141.9,27.6,142.7z"
  />
  <path
    class="st2"
    d="M231.6,106.3c-0.4,0.5-0.9,0.9-1.4,1.2c-1.7,1-3.8,1-5.4-0.2c-2.1-1.5-0.4-3.4,1.3-5.5c6.6-8.4,5-12.3,4.6-14
	c-0.3-1.1-2-2.9-4.2-4c-4-2.2-8.5-3.3-13.1-3.4c-1,0-2.1,0-3.1,0.1c-0.1,0-0.3,0-0.5,0c-0.1-3.9-0.3-7.7-0.7-11.4
	c1.1,0.3,2.4,0.6,3.7,0.9c4.8,1,10.8,2.1,17.8,5.8c4.8,2.6,7.8,5.1,8.8,9.2C241.2,92.1,237,99.5,231.6,106.3z"
  />
  <path
    class="st3"
    d="M195.1,141.7c-1.9,1.6-1.2,5.5,2.8,6.1c5.1,0.8,7.9-8.7,10.2-8.3c2.6,0.6,5.2,0.8,7.9,0.8
	c2.4,0,4.7-0.5,5.9-2.2c1.3-1.9,2.1-4,2.6-6.2c0.4-2.1-0.3-2.9-2.8-5.3c6-7.3,16.2-9.1,22.3-15.6c-0.5,0.4-1.2,0.6-1.9,0.4
	c0.9,0.2,1.6,0.1,1.9-0.4c1.5-1.7-2.3-7.9-8.4-13.7s-12.3-9.3-13.8-7.5c-0.1,0.1-0.2,0.3-0.2,0.5c-4.3,8-7.9,21.6-9.9,27
	s-6,7.8-7.8,11.2C202.6,130.7,197.9,139.3,195.1,141.7z"
  />
  <path
    class="st4"
    d="M201.3,146.8c3.1-2.3,5.1-7.7,6.8-7.3c2.6,0.6,5.2,0.8,7.9,0.8c2.4,0,4.7-0.5,5.9-2.2c1.3-1.9,2.1-4,2.6-6.2
	c0.4-2.1-1-7.3,0-8.2c6-5.1,14.2-7.2,19.5-12.8l-0.3,0.3l0.3-0.3c1.3-1.5-1.4-6.3-6.1-11.4c-4.2,7.8-12.4,16.3-14.4,18.9
	c-2.2,2.8-5.3,6.9-5.2,9.3c0.1,2.4-0.4,11.9-5.3,12.1c-2.6,0.1-6.7-2.9-8.2-4.8c-1.6,2.9-4.8,11-10.3,7.9c-0.3,1-0.2,2,0.1,2.9
	c0.4,0.6,0.9,1,1.5,1.3C197.8,147.1,199.6,147,201.3,146.8z"
  />
  <path class="st5" d="M113,76l-1.1,0.3l-1.2,0.3c0,0,0,0.1,0,0.1l1.2-0.3l1.1-0.3h0C113,76.1,113,76,113,76z" />
  <path
    class="st6"
    d="M176.1,187.5c-4.2,0-8.6,0.1-13.1,0.3c-9,0.4-17.5,1.3-25.2,2.4l0,0c0,0-28.1,3.6-47.6,5.7
	c-1.9,0.2-3.7,0.3-5.6,0.3c-16.1,0-26.3-7.5-45.8-7.5c-27.5,0-34.9,17.3-19.9,17.3c2.2-0.1,4.4-0.3,6.5-0.8c7.4-1.6,15-2.3,22.6-2.2
	c24.1,0,51.2,5.5,62.6,8.4l0.1-0.1c8.9,2.8,23.5,4.4,40.5,4.4c4.2,0,8.6-0.1,13.1-0.3c34.4-1.6,62-9.1,61.6-16.7
	C225.6,192,204.2,187.5,176.1,187.5"
  />
  <path class="st7" d="M30.7,68.4c12.1-0.6,15.4,5.4,44.4,5" />
  <path
    class="st5"
    d="M122.2,121.8c-7.3,5.4-15.7,8.1-24.7,12.1c-7.4,3.1-14.4,7-20.9,11.7c-9.9,7.2-20.5,18-31.7,35.6
	c-0.4,0.6-1,1.1-1.6,1.4c-0.6,0.3-1.2,0.4-1.9,0.4c-1.3,0-2.6-0.4-3.7-1.2c-7.8-5.7-15.9-12.8-22.1-22.3
	C9.4,150,5.2,138.3,5.2,123.4c0-1.6,0-3.2,0.1-4.8c0.2-5.3,1.3-10.5,3.4-15.3c1.8-3.9,4-7.6,6.7-11c5-6.6,10.6-12.3,14.2-21.7
	c0.1-0.3,0.3-0.6,0.4-0.9c-4.6,0-9.2,0.5-13.7,1.3c-0.3,0.1-0.5,0.1-0.8,0.1c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.3-1.9-1.3-3
	c0-0.4,0.1-0.7,0.2-1.1c1.8-5.9,4.4-11.5,7.8-16.6c4.2-6.3,10.2-12.6,18.4-16.2c3.8-1.7,8-2.6,12.2-2.7c3.9,0,7.7,0.8,11.2,2.4
	c3.6,1.6,7,3.5,10.2,5.7c6.7,4.5,13.5,9.7,21.7,13.1c5.9,2.5,12.3,3.8,18.8,3.8h1.7c-0.4,0.8-0.7,1.7-1,2.5h-0.8
	c-11.4,0-20.3-3.6-27.9-8.1c-7.6-4.5-14-9.8-20.5-13.2c-4.4-2.3-8.7-3.8-13.5-3.8c-3.9,0-7.7,0.9-11.2,2.5
	c-7.6,3.3-13.3,9.2-17.3,15.3c-3.2,4.9-5.7,10.3-7.4,15.9c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.5,0.2,0.9,0.5,1.2c0.4,0.3,0.9,0.5,1.4,0.5
	H16c4.8-1,9.7-1.4,14.6-1.4c0.2,0,0.5,0,0.7,0.1c0.1,0,0.2,0.1,0.3,0.1h0.6c2.5,0,5,0.3,7.4,0.8c2.4,0.4,4.7,1.1,7.4,1.7
	c5.5,1.3,12.7,2.5,25.2,2.5H75c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2h-2.8c-7.1,0.1-14.1-0.4-21.1-1.6c-5-0.9-8.6-2-11.9-2.7
	c-2.2-0.5-4.5-0.8-6.8-0.8c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.4-0.2,0.7-0.4,1.1C29,78.7,25,83.9,21.1,88.8c-3.9,4.9-7.7,9.4-10.2,15.3
	c-1.9,4.6-3,9.4-3.2,14.4c-0.1,1.6-0.1,3.1-0.1,4.6c-0.2,12.3,3.3,24.4,10,34.8c5.9,9.1,13.8,16.1,21.5,21.7
	c0.6,0.5,1.4,0.8,2.2,0.8c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.4-0.3,0.6-0.5c12.7-20,24.8-31.4,36-38.8c11.2-7.4,21.4-10.7,30.2-14.6
	c4.5-2,8.8-4.5,12.7-7.5C121.9,119.8,122,120.8,122.2,121.8z"
  />
  <path
    class="st5"
    d="M27.9,141.9c4.3-9.1,9-14.6,14-18.3c3.6-2.6,7.7-4.5,11.9-5.9c6.2-2.1,12.8-3.5,19.4-6.6s13.2-7.9,19.2-16.8
	c0.4-0.6,0.3-1.3-0.3-1.7c-0.6-0.4-1.3-0.3-1.7,0.3l0,0c-5.2,7.6-10.6,12-16.2,15c-4.1,2-8.3,3.7-12.7,4.9c-6.4,1.9-12.9,3.6-19,7.5
	s-11.9,10-16.8,20.6c-0.3,0.6-0.1,1.3,0.5,1.6c0.6,0.3,1.3,0.1,1.6-0.5C27.9,142,27.9,141.9,27.9,141.9L27.9,141.9z"
  />
  <path
    class="st5"
    d="M40.5,48.5c2.8-1.3,5.9-1.9,9-1.9c4.6,0,9.1,1.5,13.9,3.8s10,5.1,16.1,7.7c7.2,3.1,15,4.8,22.9,5
	c1.1,0,2.1-0.1,3.2-0.2c0.7-0.2,1.1-0.8,0.9-1.5c-0.1-0.6-0.7-1-1.3-0.9l0,0c-0.1,0-1.1,0.1-2.9,0.1c-7.6-0.2-15.1-1.8-22-4.9
	c-5.9-2.5-11.1-5.4-16-7.6s-9.7-4-14.9-4c-3.4,0-6.8,0.7-9.9,2.1c-0.6,0.3-0.9,1-0.6,1.6c0,0,0,0,0,0c0.2,0.6,0.9,0.9,1.5,0.7
	C40.4,48.5,40.5,48.5,40.5,48.5z"
  />
  <path
    class="st2"
    d="M163.9,184.2c0,0-9.1,9.5-12.9,13.8c-1.3,1.4-2.4,3.1-2.4,4.8c0,2-0.4,3.1-1.6,3.5c-3.8,1-7.8,1.4-11.7,1.3
	c-2.6,0-2-4.6,1.2-7.1c1.2-0.9,2.4-1.7,3.8-2.4c0.8-0.4,1.4-1.1,1.5-2l1.8-12.3L163.9,184.2z"
  />
  <path
    class="st2"
    d="M171.3,182c0,0,8.6,6.1,11.7,10.2c1,1.4,1.5,3.2,1.4,4.9c-0.1,1,0.7,1.9,1.8,2c0.1,0,0.2,0,0.2,0
	c3.8-0.1,7.6-1,11.1-2.5c2-1.1,1.4-4.1-1.5-5.8c-1.1-0.7-2.3-1-3.6-1c-1.2,0-2.3-1-2.4-2.2l-1.2-12L171.3,182z"
  />
  <path
    class="st8"
    d="M133.9,77.3c4.4,26.9,6.9,56.4,4.9,82.4c-0.7,8.6,6,14.1,13.4,13.5c11.7-1.1,23.2-4,34-8.5
	c8.4-3.5,14.6-10.8,16.7-19.6c7.4-28.8,9-60.5,4.8-88.5c-1.3-8.7-7.7-13.4-16.3-12.7c-14.4,1-33.3,4.8-46.4,8.6
	C134.1,55.6,132.1,66.5,133.9,77.3z"
  />
  <path
    class="st2"
    d="M213.4,80.4c-0.1-3.5-0.3-7-0.6-10.4c-0.5-6.3-1.4-12.4-2.5-18.4c-0.3-1.5-0.6-3.1-1-4.6
	c-2-8.6-8.9-12.4-18.1-11.7c-15.4,1.1-35.9,5.7-50,9.7c-11.5,3.4-16.8,16.1-14.3,27.5c6.2,27.3,9.8,60.3,6.7,99.1
	c-0.8,10.7,6.2,16.8,14.1,16.6c11.3-0.2,24.7-4,36.9-8.9c9.1-3.4,16.1-11.1,18.6-20.5C210.1,133.1,214.1,105.9,213.4,80.4z
	 M202.9,145.1c-2.1,8.8-8.3,16.1-16.7,19.6c-10.9,4.5-22.3,7.4-34,8.5c-7.4,0.6-14.1-4.9-13.4-13.5c2-26-0.5-55.5-4.9-82.4
	c-1.8-10.8,0.2-21.7,11.1-24.8c13.1-3.8,32-7.6,46.4-8.6c8.6-0.7,15,4,16.3,12.7c0.6,4.1,1.1,8.3,1.5,12.5c0.3,3.8,0.6,7.6,0.7,11.4
	C210.6,101.9,208.2,124.3,202.9,145.1z"
  />
  <path class="st9" d="M113,76l-1.1,0.3l-1.2,0.3c0,0,0,0.1,0,0.1l1.2-0.3l1.1-0.3h0C113,76.1,113,76,113,76z" />
  <path class="st10" d="M163.1,123.9c0,0,5.1,11.3,27.8,4.1c-5.1,5.1-11.3,12.3-19.5,9.3S163.1,123.9,163.1,123.9z" />
  <path
    class="st11"
    d="M145.5,133.5c-0.8,8.4-1,16.9-0.4,25.4c0.4,4.9,1.9,8.2,10.7,7.1s20.6-5,23.2-5.7c4.7-1.2,4.4-4.6,1.2-4.3
	c-4.9,0.5-19.3,2-23.6,1.3s-6.9-0.6-7-7.2s0.3-15.9-0.5-18.9S146,128.6,145.5,133.5z"
  />
  <path
    class="st12"
    d="M210.2,45c-2.5-10.7-12.7-16.7-24.6-16.3c-14.6,0.5-38.3,4.2-54.3,10.3c-17,6.7-23.3,22.3-19.4,37.4
	c1.1,4.3,2.2,8.4,3.3,12.4c-3.3,3.7-6.8,8-9.9,13.1c-3,5-3.3,9.3-1.3,13.1c3.3,6.4,9.8,10.4,18.8,12.2c1,10.1,1.3,21.2,0.4,34.6
	c-0.9,13.9,3,20.2,9.5,23.7c5.2,2.9,11.1,4.2,17,3.9c11.5-0.8,24-4.7,35.1-9c9.6-3.5,16.9-11.6,19.4-21.5C214,123,218.4,81,210.2,45
	z M114.5,110.5c-0.2-2.3,1.6-5.5,4-8.3c1.1,4.6,2,9.1,2.8,13.7C115.8,114.1,114.7,111.8,114.5,110.5z M203.2,158.8
	c-2.5,9.4-9.5,17.1-18.6,20.5c-12.2,4.9-25.6,8.7-36.9,8.9c-7.9,0.2-14.9-5.9-14.1-16.6c3.1-38.8-0.5-71.8-6.7-99.1
	c-2.5-11.4,2.8-24.1,14.3-27.5c14.1-4,34.6-8.6,50-9.7c9.2-0.7,16.1,3.1,18.1,11.7c0.4,1.5,0.7,3.1,1,4.6
	C216.8,84.7,212.8,123.1,203.2,158.8z"
  />
  <path
    class="st5"
    d="M146.1,127.4c-0.2-0.1-0.3-0.1-0.5-0.2c0.5-1.2,0.4-2.6-0.3-3.8c-0.5-0.7-1.4-1.1-2.3-1.1c-0.2,0-0.4,0-0.5,0.1
	c-0.1,0.2-0.2,0.4-0.3,0.5c-0.3,0.7-0.7,1.4-1.3,2c-0.3,0.3-0.6,0.6-1,0.8c1-0.2,1.9-0.5,2.8-1h0.2c1.4,0-1,4.3,0,4.3h0.1
	c0.5,0,0.9,0.2,1.4,0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.6-0.5,1.2-1,1.7-1.5C146.3,127.5,146.2,127.5,146.1,127.4z"
  />
  <path class="st13" d="M163.5,81.7c0.6,3.7-4,7.4-10.2,8.4s-11.7-1.3-12.2-5s4-7.4,10.2-8.4S163,78,163.5,81.7z" />
  <path class="st13" d="M207.1,70.7c0.4,2.6-2.9,5.3-7.3,6s-8.3-0.9-8.7-3.5s2.9-5.3,7.3-6S206.7,68.1,207.1,70.7z" />
  <path
    class="st10"
    d="M196.2,124.3c0,0.5-0.2,1.1-0.7,1.5c0.1-0.1,0.2-0.3,0.3-0.4C196,125.1,196.2,124.7,196.2,124.3z"
  />
  <path
    class="st14"
    d="M171.6,130.9c-2.7-1.3-5.7-1.5-8.5-0.6c1.5,3,4,5.4,7.1,6.9c2.6,1.2,5.6,1.4,8.4,0.5
	C177.1,134.7,174.6,132.3,171.6,130.9z"
  />
  <path
    class="st10"
    d="M196.2,124.3c0-0.4-0.1-0.7-0.4-1.1c-0.6-0.8-1.8-1-2.6-0.4c-0.1,0.1-0.2,0.2-0.4,0.3c0.6-0.8,1.8-1,2.6-0.4
	C195.9,123.2,196.2,123.8,196.2,124.3z"
  />
  <path
    class="st10"
    d="M195.8,123.3c-0.6-0.8-1.8-1-2.6-0.4c-0.1,0.1-0.2,0.2-0.4,0.3c0,0,0,0,0,0c-4.6,3.3-10,5.2-15.7,5.3
	c-3.3,0.1-6.5-0.8-9.3-2.5c-1.1-0.8-2.1-1.8-2.8-2.9c-0.6-1-1-2.1-1.2-3.2v-0.5c0-0.1,0-0.2,0-0.3c0.8-0.4,1.7-0.9,2.4-1.5
	c0.8-0.6,1-1.7,0.4-2.5c0,0,0-0.1-0.1-0.1c-0.6-0.7-1.7-0.8-2.5-0.2c0,0,0,0,0,0c-1.8,1.2-3.9,2.1-6,2.6c-0.9,0.2-1.5,1.1-1.3,2
	c0,0.1,0,0.1,0,0.2c0.2,0.9,1.1,1.5,2.1,1.3c0,0,0.1,0,0.1,0c0.4-0.1,0.8-0.2,1.2-0.3c0.1,5.8,1.4,10.7,3.7,14.2
	c1.1,1.7,2.7,3.2,4.5,4.2c1.8,1,3.8,1.5,5.9,1.5c3.4,0,6.9-1.3,10.6-3.8c4.1-3,7.8-6.7,10.7-10.9c0.1-0.1,0.2-0.3,0.3-0.4
	c0.2-0.3,0.4-0.7,0.4-1C196.2,124,196,123.6,195.8,123.3z M182.7,133.6c-2.5,1.9-5.4,2.9-8.5,3.1c-1.4,0-2.8-0.3-4.1-1
	c-2.1-1.2-3.6-3.2-4.5-5.4c-0.2-0.6-0.5-1.3-0.6-1.9c0.5,0.4,1.1,0.8,1.7,1.2c0.2-0.3,0.5-0.4,0.8-0.4c1.2,0.1,2.3,0.3,3.4,0.7
	c1.1,0.4,2.1,1,3,1.6c0.2,0.1,0.3,0.3,0.4,0.5c0.9,0.1,1.8,0.2,2.8,0.1c3.1,0,6.2-0.6,9.2-1.5C185.1,131.7,183.9,132.7,182.7,133.6z
	"
  />
  <path
    class="st12"
    d="M178.6,41.4c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5C177.9,39.9,178.6,40.6,178.6,41.4z"
  />
  <path
    class="st12"
    d="M172,41c0.7,0,1.5,0.2,1.5,1.2c0,1-0.8,1.8-1.8,1.8c-3,0.4-5.9,1-8.8,1.8c-0.8,0.2-2,0.2-2.1-0.9
	c0-1,0.7-1.9,1.7-2c3-0.9,6.1-1.5,9.2-1.8L172,41z"
  />
  <path class="st10" d="M166.9,63c0.2,2.6-0.9,4.9-2.6,5s-3.2-1.9-3.4-4.5s0.9-4.9,2.6-5S166.7,60.4,166.9,63z" />
  <path class="st10" d="M191.8,58.5c0.2,2.5-0.9,4.7-2.5,4.8s-3-1.8-3.3-4.3s0.9-4.7,2.5-4.8S191.5,55.9,191.8,58.5z" />
  <path
    class="st10"
    d="M186.8,51.5c-0.1,0.2-0.1,0.5,0.1,0.6c0.9,0.7,1,2.9,1,2.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7
	c0,0,0,0,0,0c0-0.1-0.4-2.7-1.8-3.6C187.2,51.3,187,51.2,186.8,51.5z"
  />
  <path
    class="st10"
    d="M189.9,51.4c-0.2,0.1-0.3,0.3-0.1,0.6c0.6,1-0.2,3.1-0.2,3.1c-0.1,0.4,0.1,0.8,0.5,0.9
	c0.3,0.1,0.7-0.1,0.8-0.4c0-0.1,0.6-2.7-0.4-4C190.4,51.4,190.2,51.2,189.9,51.4z"
  />
  <path
    class="st10"
    d="M183.9,53.5c0,0.2,0,0.4,0.4,0.5c1.1,0.3,2.2,2.2,2.2,2.2c0.1,0.4,0.5,0.6,0.9,0.5c0.4-0.1,0.6-0.5,0.5-0.9
	c0,0,0-0.1-0.1-0.1c0-0.1-1.6-2.3-3.2-2.5C184.3,53.2,184,53.2,183.9,53.5z"
  />
  <path
    class="st10"
    d="M161.4,55.8c-0.1,0.2-0.1,0.5,0.1,0.6c0.9,0.7,1,2.9,1,2.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7
	c0,0,0,0,0,0c0-0.1-0.4-2.7-1.8-3.6C161.8,55.6,161.6,55.5,161.4,55.8z"
  />
  <path
    class="st10"
    d="M164.5,55.7c-0.2,0.1-0.3,0.3-0.1,0.6c0.6,1-0.2,3.1-0.2,3.1c-0.1,0.4,0.1,0.8,0.5,0.9
	c0.3,0.1,0.7-0.1,0.8-0.4c0-0.1,0.6-2.7-0.4-4C165,55.7,164.8,55.5,164.5,55.7z"
  />
  <path
    class="st3"
    d="M148.9,141.3c-2,4.5-5.4,5-10.5,5.4c-0.2-0.2-0.5-0.3-0.8-0.3c-3.7,0-8.8-1.8-11.4-5.3c-4-5.4-9-7.8-12.6-9.5
	c-3.6-1.7-6.2-3-5.9-6c0-4,2.8-8.5,7.5-12.1c5.3-4.1,10.2-4.8,12.6-4.8c1,0,2,0.1,2.9,0.4c0.3,0.1,0.6,0.3,0.8,0.6
	c1.3,2.6,2.1,5.5,2.3,8.4c0.2,2.1,0.4,3.8,1.9,5.7c0.7,0.7,1.6,1.1,2.6,1.1c0,0,0,0,0,0c0.5-0.1,1.1-0.3,1.5-0.7c0,0,0,0,0.1-0.1
	c1.9-2,2.2-6.8,5.9-5.9c3.1,0.7,4.7,4.5,3.2,7.6c-0.6,1.2-1.6,2.3-2.6,3.3c0.2,0.1,0.5,0.2,0.7,0.2c1.5,0,2.8,0.8,3.6,2.1
	C152.1,133.8,150.7,137.3,148.9,141.3z"
  />
  <path
    class="st10"
    d="M158.5,57.8c0,0.2,0,0.4,0.4,0.5c1.1,0.3,2.2,2.2,2.2,2.2c0.2,0.3,0.5,0.5,0.9,0.4c0.3-0.2,0.5-0.5,0.4-0.9
	c0-0.1-1.6-2.3-3.2-2.5C158.9,57.5,158.6,57.5,158.5,57.8z"
  />
  <path
    class="st4"
    d="M129.2,139.2c-2.2-2.5-0.5-5.6-4.7-9.3c-4.8-2.9-11.5-7-12.4-13.6c-0.9,1.7-2.1,3.3-3.4,4.8
	c-0.7,1.4-1.1,2.9-1.1,4.5c-0.3,3,2.5,4.3,5.9,6c3.6,1.8,8.6,4.2,12.6,9.5c2.6,3.5,7.7,5.3,11.4,5.3h0.7c3.3-0.2,6-0.5,7.9-2
	C143.8,144.6,134.2,145,129.2,139.2z"
  />
  <path
    class="st5"
    d="M139.9,125.7c-0.1,0.1-0.3,0.1-0.4,0.2c-0.5,0.2-1,0.3-1.6,0.3c-0.7,0-1.4-0.1-2-0.4c-0.6-0.2-1.1-0.7-1.5-1.2
	c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2-0.1-0.3,0-0.4c0.1,0.2,0.3,0.4,0.4,0.6c0.9,1.1,2.3,1.6,3.7,1.5
	C138.8,125.9,139.4,125.8,139.9,125.7z"
  />
  <path
    class="st5"
    d="M244.8,107c-0.9-1.8-2-3.5-3.3-5c-1-1.2-2-2.4-3.1-3.5c0.1-0.2,0.2-0.3,0.3-0.5c1.5-3,2.4-6.2,2.5-9.6
	c0-1.3-0.1-2.6-0.5-3.8c-0.6-2.2-1.7-4.1-3.3-5.7c-1.8-1.7-3.9-3.1-6.2-4.2c-4.1-2.2-8.5-3.8-13-4.8c-1-0.2-2-0.5-2.9-0.7
	c-0.7-8.2-2-16.5-3.8-24.5c-1.2-5.2-4.4-9.8-8.9-12.8c-4.7-3-10.1-4.6-15.7-4.5h-1.2c-0.2,0-0.3,0-0.5,0c0.6-1.9,0.9-4,1-6
	c0-2.6-0.6-5.1-1.9-7.3c-1.5-2.5-3.8-4.4-6.5-5.5c-2.6-1.1-5.4-1.6-8.2-1.6c-5.7,0-12,1.7-18.3,4s-12.7,5.3-18.4,8
	c-4.6,2.2-10.7,3.3-17.4,3.2c-6.7-0.1-13.4-1-19.9-2.8c-6.4-1.7-12.5-4.3-18.1-7.8c-0.9-0.5-2.1-0.2-2.6,0.8
	c-0.5,0.8-0.2,1.9,0.6,2.4c5.9,3.7,12.4,6.5,19.1,8.3c6.8,1.9,13.8,2.9,20.9,2.9c7.1,0,13.7-1.1,19-3.6c5.7-2.7,12-5.6,18.1-7.8
	c6.1-2.2,12.1-3.8,17-3.8c2.3,0,4.6,0.4,6.7,1.2c2,0.8,3.7,2.2,4.8,4c1,1.6,1.5,3.4,1.4,5.3c0,2.2-0.5,4.4-1.4,6.4
	c-3.1,0.2-6.4,0.6-9.9,1c0,0,0,0,0-0.1c-0.4-2.6-1.6-5.1-3.4-7.1c-1-1.1-2.3-2-3.8-2.6c-1.7-0.7-3.5-1-5.3-1h-1.2
	c-1.6,0.2-3.2,0.5-4.7,1.1c-3.4,1.3-6.7,2.8-9.9,4.5c-2.2,1.1-4.6,2.2-7.1,3.4c-1.8-0.4-3.6-0.6-5.5-0.6c-2.2,0-4.4,0.2-6.5,0.7
	c-6.3,1.4-12.7,2.1-19.1,2.1c-10.5,0-22.6-2.1-36.6-8.6c-0.9-0.4-2.1,0-2.5,1c-0.4,0.9,0,2,0.9,2.4c14.5,6.7,27.2,8.9,38.2,8.9
	c6.7-0.1,13.4-0.8,19.9-2.2c1.1-0.2,2.2-0.4,3.4-0.5c-11,4.3-22.6,6.5-34.4,6.5c-5.4,0-10.8-0.4-16.2-1.3c-1-0.2-2,0.5-2.2,1.5
	c0,0,0,0,0,0c-0.2,1,0.5,2,1.5,2.2c0,0,0.1,0,0.1,0c5.5,0.9,11.2,1.4,16.8,1.4c17.4,0,31.2-4.6,41.9-9.3l0.9-0.4
	c1.3,0.3,2.5,0.8,3.6,1.5c0.9,0.5,1.7,1.2,2.4,2c-4,1.1-7.9,2.3-11.4,3.6c-6.5,2.3-12.1,6.6-16.1,12.2c-3.5,5.2-5.4,11.2-5.4,17.5
	c0,3,0.4,6.1,1.2,9l0,0c1.1,4.2,2.2,8.3,3.3,12.2c-3.2,3.6-6.5,7.8-9.5,12.7c-1.7,2.6-2.7,5.5-2.8,8.6c0,2,0.5,3.9,1.4,5.6
	c1.1,2,2.5,3.9,4.2,5.5c-0.6,1.4-0.9,2.8-0.9,4.2c-0.3,3.8,3.2,5.5,6.6,7.1c2.8,1.4,6.2,3,9.4,6c0.1,2.4,0.1,4.9,0.1,7.5v1.6
	c-1.7,0.9-3.2,2.2-4.4,3.7l-0.2-0.1c0,0-0.2,0.3-0.4,1c-0.2,0.4-0.3,0.7-0.4,1.1l-0.1,0.4c0,0.1-0.1,0.3-0.1,0.5
	c0,0.2-0.1,0.3-0.1,0.4l-0.1,0.5c0,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.2,0,0.4c0,0.3-0.1,0.6-0.1,1v0.2c0,0.3,0,0.6,0,0.9v1.8
	c0,0.4,0,0.7,0.1,1.1v0.3c0,0.5,0.1,0.9,0.1,1.4l0.1,0.4c0.1,0.4,0.1,0.8,0.2,1.3v0.2c0.1,0.5,0.2,1,0.4,1.5c0,0.1,0.1,0.3,0.1,0.4
	c0.2,0.5,0.3,1.1,0.5,1.7c0.1,0.3,0.2,0.6,0.3,0.8l0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.7c0,0.1,0.1,0.2,0.2,0.3l0.4,0.6l0.2,0.3
	c0.1,0.2,0.3,0.4,0.4,0.5c0.1,0.2,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.3,0.5,0.5l0.3,0.3c0.2,0.2,0.3,0.3,0.5,0.5l0.3,0.3l0.6,0.5
	l0.4,0.3l0.2,0.2v0.2c0.4,1.5,1,2.9,1.7,4.3c1.7,3.2,4.3,5.8,7.5,7.4c2.9,1.5,6,2.7,9.3,3.3l-0.9,6c-0.1,0.4-0.4,0.8-0.8,1
	c-1.4,0.7-2.8,1.6-4,2.6c-1,0.8-1.8,1.8-2.4,2.9c-0.6,1-0.9,2.1-0.9,3.2c0,0.8,0.2,1.6,0.7,2.2c0.3,0.3,0.6,0.6,1,0.8
	c0.4,0.2,0.8,0.3,1.2,0.3h1c3.7,0.1,7.4-0.4,11-1.3c0.4-0.1,0.9-0.4,1.2-0.7c0.5-0.5,0.9-1.1,1-1.8c0.2-0.7,0.3-1.5,0.3-2.2
	c0-0.7,0.2-1.4,0.6-2c0.4-0.8,0.9-1.5,1.5-2.1c1.9-2.1,5.1-5.6,7.8-8.5c0.5-0.5,0.9-0.9,1.3-1.4c2.2-0.4,4.4-0.9,6.5-1.5l0.9,0.8
	c1,0.9,2.3,1.4,3.6,1.4c0.3,0,0.7,0,1-0.1c1.3-0.3,2.5-0.9,3.5-1.9c2,1.6,3.8,3.4,5.5,5.3c0.8,1.1,1.2,2.4,1.2,3.8v0.5
	c0,1.7,1.4,3.1,3.1,3.1h0.2c2.2-0.1,4.3-0.4,6.4-0.9c1.8-0.3,3.6-0.9,5.2-1.8c0.6-0.3,1.1-0.8,1.4-1.3c0.3-0.5,0.5-1.1,0.5-1.7
	c0-1-0.3-1.9-0.9-2.7c-0.7-0.9-1.5-1.6-2.4-2.2c-1.2-0.8-2.7-1.2-4.1-1.2c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.4-0.4-0.7l-0.9-8.6
	c2.9-1.7,5.5-3.8,7.8-6.3c2.1-2.3,3.8-4.9,5.1-7.7c0-0.1,0-0.1,0.1-0.2c2.7-1.5,6.9-3.8,9-10.4c1.6-5.1,1.6-9.9,0.6-13.1
	c0.8,0.1,1.7,0.1,2.5,0.1h0.1c1.3,0,2.6-0.1,3.8-0.5c1.2-0.4,2.3-1.1,3-2.2c1.4-2,2.3-4.3,2.8-6.7c0.1-0.3,0.1-0.6,0.1-0.9
	c0-0.9-0.2-1.9-0.4-2.8c-0.2-0.8-0.3-1.5-0.3-2.3c0-0.2,0-0.3,0.1-0.5c0-0.1,0.1-0.1,0.1-0.2c2.1-2.5,5.3-4.3,8.9-6.2
	c4-1.9,7.6-4.4,10.8-7.5l0.1-0.1c0.2-0.3,0.6-0.6,0.7-0.9c0.1-0.3,0.1-0.6,0.1-0.9C245.6,108.8,245.3,107.8,244.8,107z M217.7,72.2
	c4.3,1,8.5,2.5,12.4,4.5c2,1,3.9,2.3,5.6,3.8c1.3,1.3,2.2,2.9,2.7,4.6c0.3,1,0.4,2,0.4,3.1c-0.1,2.9-0.9,5.8-2.2,8.4
	c-0.1-0.1-0.2-0.2-0.3-0.3c-1.3-1.2-2.6-2.4-4-3.5c0.2-0.8,0.3-1.5,0.3-2.3c0-0.7-0.1-1.3-0.2-2c-0.1-0.4-0.2-0.8-0.3-1.2
	c-0.1-0.5-0.4-0.9-0.7-1.3c-1.1-1.4-2.6-2.6-4.2-3.4c-3.5-1.9-7.4-3-11.4-3.4c-0.1-2.5-0.2-5-0.4-7.5
	C216.2,71.8,216.9,72,217.7,72.2z M215.9,86c0-1.4,0-2.8,0-4.1c3.5,0.4,6.9,1.4,10,3c0.9,0.4,1.8,1,2.5,1.8c0.3,0.3,0.6,0.6,0.8,0.9
	c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.4,0.2,0.7,0.3,1.1c0.1,0.5,0.2,1,0.2,1.5c0,0.1,0,0.3,0,0.4c-0.4-0.3-0.8-0.5-1.2-0.8
	c-1-0.6-2.1-1.2-3.2-1.7c-0.9-0.4-1.8-0.7-2.8-0.7c-0.4,0-0.8,0-1.1,0.2c-0.4,0.1-0.7,0.4-1,0.7c-0.2,0.2-0.4,0.6-0.5,0.9
	c-1.9,3.7-3.5,7.6-4.8,11.5C215.7,96.2,215.9,91.1,215.9,86z M141,28.8c3-1.4,5.7-2.8,8.1-3.9c1.6-0.8,3.3-1.5,5-2.1
	c1.2-0.4,2.4-0.7,3.7-0.9h0.9c1.7,0,3.3,0.3,4.8,1.1c0.8,0.5,1.5,1.1,2.1,1.9c0.8,1.2,1.4,2.6,1.7,4c0,0.1,0,0.3,0.1,0.4
	c-6.9,1-14.2,2.4-21.2,4.1c-0.2-0.3-0.3-0.5-0.5-0.8C144.4,31,142.8,29.7,141,28.8z M105.2,114.6c-0.8-1.4-1.1-2.9-1.1-4.5
	c0.1-2.6,0.9-5.2,2.4-7.4c2.5-4.2,5.4-7.8,8.2-11.1c0.9,3.5,1.8,6.9,2.5,10.3c-0.3,0.4-0.7,0.8-1,1.2c-0.8,1.1-1.5,2.3-2.1,3.5
	c-0.5,1.1-0.8,2.2-0.8,3.4v0.5c0.1,0.7,0.4,1.4,0.8,2c-2.5,1.9-4.4,4.1-5.8,6.4C107.1,117.7,106.1,116.2,105.2,114.6z M118,105.1
	c0.3,1.5,0.6,3,0.9,4.5c-1,0.5-1.9,1-2.8,1.6c-0.1-0.2-0.2-0.5-0.2-0.7v-0.3c0-0.9,0.2-1.7,0.6-2.5
	C116.9,106.8,117.4,105.9,118,105.1z M122.2,134.8c-6.7-5.2-13.6-5.7-13.2-9.4c0-0.7,0.1-1.5,0.3-2.3c0.2-0.8,0.5-1.5,0.9-2.4
	c1.1-2.1,2.9-4.3,5.5-6.4c0.1-0.1,0.1-0.1,0.2-0.2c0.6-0.4,1.2-0.9,1.8-1.2c0.5-0.3,1.1-0.6,1.6-0.9c0.7-0.4,1.5-0.7,2.2-1
	c2-0.7,4-1.1,6.1-1.2c0.9,0,1.8,0.1,2.6,0.3c3.2,6.5,1.2,9.5,3.9,13.6c0,0,0,0,0,0c0.1,0.2,0.3,0.4,0.4,0.6c0.9,1.1,2.3,1.6,3.7,1.5
	c0.5,0,1.1-0.1,1.6-0.2c0.4-0.2,0.7-0.5,1-0.8c0.6-0.6,1-1.3,1.3-2c0.1-0.2,0.2-0.4,0.3-0.5c0.4-0.8,0.8-1.7,1.1-2.2
	c0.2-0.3,0.4-0.5,0.7-0.7c0.2-0.1,0.5-0.2,0.7-0.2c0.2,0,0.4,0,0.6,0.1c0.8,0.2,1.5,0.7,2,1.4c0.5,0.7,0.8,1.6,0.8,2.5
	c0,0.7-0.1,1.4-0.4,2c-0.5,0.8-1,1.6-1.6,2.3c-0.5,0.6-1.1,1.1-1.7,1.5c-0.1,0.1-0.2,0.2-0.3,0.2c-0.5,0.4-1.1,0.8-1.4,1.1
	c-0.2,0.1-0.4,0.3-0.5,0.3l-0.1,0.1c-0.4,0.2-0.6,0.6-0.6,1c0,0.2,0,0.4,0.1,0.6c0,0,0,0.1,0.1,0.1c0.3,0.6,1,0.8,1.6,0.5
	c0,0,0,0,0.1,0c0.9-0.6,1.8-1.2,2.7-1.9c0.3-0.2,0.6-0.5,1-0.8c4.3,0.9,2.3,5.8,0.3,10.1c-1.6,3.7-4.2,4.3-9.4,4.6h-0.6
	c-3.5,0-8.1-1.7-10.4-4.8c-0.8-1.1-1.7-2.1-2.6-3C123.9,136.2,123,135.5,122.2,134.8z M150.1,197.2c-0.7,0.8-1.3,1.6-1.8,2.5
	c-0.5,0.9-0.9,2-0.9,3.1c0.1,0.6-0.1,1.2-0.3,1.8c-0.1,0.2-0.3,0.4-0.5,0.5c-3.4,0.9-6.9,1.3-10.4,1.2H135c-0.1,0-0.1,0-0.1-0.1
	c-0.1-0.1-0.1-0.3-0.1-0.6c0-0.7,0.2-1.4,0.6-2c0.4-0.8,1-1.6,1.8-2.1c1.1-0.9,2.3-1.6,3.6-2.3c1.2-0.5,2-1.6,2.2-2.9l0.9-6
	c1.4,0.2,2.9,0.3,4.3,0.3c0.6,0,1.1,0,1.7-0.1c2.4-0.2,4.8-0.5,7.2-0.9C154.5,192.3,151.8,195.3,150.1,197.2z M163.8,186.1
	c-1.4,0.3-2.8,0.6-4.2,0.9c-3.3,0.6-6.6,1.1-10,1.4h-1.5c-1.3,0-2.6-0.1-3.9-0.3c-0.8-0.1-1.6-0.2-2.4-0.4c-3-0.6-5.8-1.7-8.5-3.1
	c-2.8-1.4-5.1-3.6-6.5-6.4c-0.2-0.4-0.5-0.9-0.7-1.4l0-0.2h0c0.4,0.2,0.8,0.4,1.2,0.6l0.3,0.1l1,0.4l0.4,0.1l1.3,0.4h0.1
	c0.5,0.1,1,0.2,1.5,0.4l0.5,0.1c0.4,0.1,0.7,0.1,1.1,0.2l0.5,0.1c0.5,0.1,1.1,0.1,1.6,0.2c7.4,0.6,14.9,0.4,22.3-0.4l5.1,4.6
	l1.8,1.7l0.7,0.6C165,185.8,164.4,185.9,163.8,186.1z M156,161.3l1.2-1.5c0.6-0.9,1.6-1.5,2.7-1.7l25.5-4.5c0.2,0,0.4-0.1,0.6-0.1
	c0.8,0,1.5,0.3,2.1,0.8l0.9,0.9h-0.1c-2.5,0.6-5.2,1.1-7.9,1.6l-1.6,0.3c-4.1,0.8-8.2,1.6-11.8,2.2l-1.4,0.3l-2.1,0.4l-0.4,0.1
	l-6.2,1.1h-0.2l-0.7,0.1h-0.1l-0.4,0.1H156z M175.2,185.7c-0.1,0.2-0.3,0.3-0.5,0.5c-0.6,0.6-1.3,1-2.2,1.1c-0.2,0-0.4,0.1-0.6,0.1
	c-0.7,0-1.4-0.3-1.9-0.7c0,0,0,0-0.1,0l-1.9-1.7l-7.1-6.5c1-0.1,2-0.3,3-0.5c1.4-0.2,2.9-0.5,4.5-0.8c0.9-0.2,1.8-0.4,2.8-0.5
	c1.7-0.4,3.4-0.7,5.1-1.1l2.4-0.6c2.2-0.5,4.3-1.1,6.1-1.6l-6.4,8.1L175.2,185.7z M192.7,191.1c1.1,0,2.1,0.3,3,0.9
	c0.7,0.3,1.2,0.9,1.6,1.5c0.3,0.4,0.4,0.8,0.5,1.3c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.3-0.4,0.4c-1.5,0.7-3,1.2-4.6,1.5
	c-2,0.4-4,0.7-6,0.8c-0.4,0-0.7-0.3-0.7-0.7v-0.4c0-1.9-0.6-3.7-1.7-5.2c-1-1.2-2.1-2.4-3.3-3.5c-0.9-0.8-1.9-1.7-2.8-2.5l1.7-2.2
	c1.9-0.7,3.7-1.3,5.5-2c1-0.4,2-0.8,2.9-1.3l0.8,7.6c0.1,0.9,0.5,1.7,1.2,2.3C191,190.7,191.8,191,192.7,191.1z M199.5,167.2
	c-0.9,1.4-1.9,2.8-3,4c-1.8,2-3.8,3.7-6.1,5.2l-2.3,1.3c-1.2,0.6-2.4,1.2-3.7,1.7c-0.5,0.2-1.1,0.4-1.8,0.7l6.5-8.2
	c3.6-1.5,7.1-3.1,10.5-4.9C199.5,167.1,199.5,167.2,199.5,167.2z M208.2,137.4c-0.2,0.8-0.3,1.7-0.5,2.5c-0.5,2.6-1.1,5.1-1.7,7.7h0
	c-1,0.8-2,1.4-3.1,2.1l-0.1,0.1c-0.6,0.3-1.1,0.7-1.8,1l-0.2,0.1c-0.6,0.3-1.3,0.7-1.9,1c-0.7,0.3-1.4,0.6-2.1,0.9h-0.1
	c-0.7,0.3-1.4,0.6-2.2,0.8l-0.3,0.1c-0.7,0.3-1.5,0.5-2.3,0.7h0l-1.9-2c-1.1-0.9-2.4-1.4-3.8-1.4c-0.3,0-0.7,0-1,0.1l-25.5,4.5
	c-1.7,0.3-3.2,1.3-4.2,2.7l-2.6,3.5H152c-2.2,0.2-4.5,0.4-6.7,0.4h-0.5c-3.6,0-7.2-0.5-10.7-1.5c-0.3-0.1-0.7-0.2-1-0.4l-0.2-0.1
	c-0.3-0.2-0.7-0.3-1-0.5c0,0,0,0,0-0.1c-0.9-0.5-3.5-2.5-5.4-4L126,155l-0.3-0.1l-0.9-0.7c0.1-2.8,0.1-5.4,0.1-8
	c0-1.6,0-3.3-0.1-4.8c0.1,0.1,0.2,0.3,0.4,0.4c2.9,4,8.5,5.8,12.4,5.8h0.8c5.3-0.3,9.2-1,11.5-6.1c1.9-4.3,3.4-8.1,1.7-11
	c-0.6-1-1.5-1.7-2.5-2.2c0.5-0.6,0.9-1.3,1.3-2c0.5-0.9,0.7-2,0.7-3c0-1.4-0.4-2.8-1.2-3.9c-0.9-1.2-2.1-2-3.5-2.4
	c-0.4-0.1-0.7-0.1-1.1-0.1c-1,0-1.9,0.4-2.6,1c-0.9,0.9-1.5,1.9-2,3c-0.4,0.9-0.8,1.7-1.4,2.4c0,0.1-0.1,0.1-0.1,0.1
	c-0.2,0-0.4,0-0.7,0.1c-0.7,0.1-1.3-0.2-1.8-0.6c-1-1.5-1.6-3.3-1.6-5.1c-0.2-3.1-1-6.1-2.4-8.8c-0.3-0.6-0.9-1.1-1.5-1.3
	c-1.2-0.1-2.3-0.2-3.5-0.2c-2.2,0.1-4.5,0.5-6.6,1.2c-0.4-2-0.8-4-1.3-6c-0.2-0.9-0.4-1.9-0.7-2.8c-0.8-3.4-1.7-6.9-2.6-10.4
	c-0.2-0.9-0.5-1.8-0.7-2.7c-0.9-3.5-1.9-7-2.8-10.7h0c-0.7-2.7-1.1-5.6-1.1-8.4c-0.1-5.7,1.6-11.4,4.9-16.1c3.7-5.2,8.9-9.2,15-11.3
	c3.6-1.4,7.7-2.7,12-3.8c0.2,0.4,0.4,0.9,0.5,1.4c0.3,1,1.3,1.6,2.3,1.4c0.9-0.2,1.5-1.2,1.2-2.1c0,0,0,0,0-0.1
	c-0.1-0.5-0.3-1-0.5-1.5c6.6-1.6,13.7-2.9,20.3-3.8c0,0.4,0,0.8,0,1.2c0,1,0.9,1.9,1.9,1.9c1,0.1,1.9-0.7,2-1.7c0,0,0-0.1,0-0.1
	c0-0.6,0-1.2-0.1-1.8c2.8-0.3,5.5-0.6,8-0.8c-0.1,0.1-0.2,0.3-0.3,0.4c-0.6,0.8-0.4,1.9,0.4,2.5c0,0,0.1,0.1,0.1,0.1
	c0.6,0.7,1.7,0.7,2.3,0c0.1-0.1,0.2-0.2,0.3-0.3c0.7-1,1.2-2,1.7-3c0.6,0,1.1,0,1.7-0.1h1.1c5.1-0.1,10.1,1.3,14.4,4
	c4,2.6,6.8,6.7,7.8,11.3c1.7,7.7,2.9,15.4,3.6,23.3c0.1,0.8,0.2,1.6,0.2,2.5c0.2,2.7,0.3,5.3,0.4,8c0,0.9,0,1.7,0.1,2.6
	c0,1.5,0,3,0,4.5c-0.1,8.5-0.5,17-1.4,25.4c-0.3,3.1-0.7,6.1-1.1,9.2C210.2,126.3,209.3,131.9,208.2,137.4z M243,110.2
	c-2.9,3.1-6.6,5.1-10.2,7c-3.6,1.9-7.1,3.8-9.6,6.8c-0.3,0.3-0.5,0.7-0.6,1.1c-0.1,0.4-0.1,0.7-0.1,1.1c0,0.9,0.2,1.9,0.4,2.8
	c0.2,0.8,0.3,1.5,0.3,2.3v0.4c-0.4,2-1.2,4-2.4,5.7c-0.4,0.6-1.1,1-1.8,1.2c-1,0.3-2,0.4-3,0.4h-0.1c-1.4,0.1-2.7,0-4-0.3
	c-0.4-0.5-0.8-0.8-1.2-1c1.7-8.5,3-17.1,3.9-25.7c0.7-2.2,1.5-4.6,2.3-7.1c1.6-4.9,3.5-9.7,5.7-14.3l0.1-0.1v-0.2h0.3
	c0.6,0,1.2,0.2,1.8,0.5c1.3,0.5,3,1.5,4.8,2.9c0.7,0.5,1.4,1,2.1,1.6c1,0.8,2,1.7,3,2.7c0.3,0.3,0.5,0.5,0.8,0.8
	c0.6,0.6,1.2,1.3,1.8,1.9c1.3,1.4,2.5,2.9,3.6,4.4c0.7,0.9,1.2,1.8,1.7,2.8c0.3,0.6,0.5,1.2,0.5,1.8V110.2z"
  />
  <path
    class="st11"
    d="M188.1,154.3c-0.6-0.5-1.3-0.8-2.1-0.8c-0.2,0-0.4,0.1-0.6,0.1l-25.5,4.5c-1.1,0.2-2.1,0.8-2.7,1.7l-4.4,6
	c-1.3,1.5-1.2,3.7,0.1,5.2l17.1,15.7c0.6,0.4,1.3,0.7,2,0.7c0.2,0,0.4-0.1,0.6-0.1c1-0.2,2-0.8,2.6-1.6l17.2-21.7
	c1.3-1.5,1.4-3.7,0.1-5.2L188.1,154.3z"
  />
  <path
    class="st0"
    d="M192.7,158.8l-4.4-4.5c-0.7-0.7-1.7-1-2.7-0.8l-25.6,4.6c-1.1,0.2-2.1,0.8-2.7,1.7l-4.4,6
	c-1.3,1.5-1.2,3.7,0.1,5.2l17,15.7c0.7,0.7,1.6,1,2.6,0.9c1.1-0.2,2.1-0.8,2.9-1.7l17.3-21.8C193.9,162.5,194,160.3,192.7,158.8z
	 M156.3,166.6l3.1-4.3c0.3-0.4,0.7-0.6,1.1-0.7l5.6-1c-0.6,0.2-1.1,0.5-1.6,0.9c-0.8,0.7-1.4,1.5-1.9,2.5c-0.4,0.9-0.7,1.8-0.8,2.8
	c-0.2,1.1-0.2,2.1-0.2,3.2c0,0.9,0.1,1.7,0.2,2.6c0.1,0.5,0.1,1,0.3,1.4l-5.9-5.3C155.8,168.1,155.8,167.2,156.3,166.6z
	 M177.7,169.1c0-0.2,0.2-0.5,0.4-0.5c0.7-0.1,1.3-0.1,2-0.1c0.3,0,0.5,0.1,0.7,0.1c0.5,0.1,0.6,0.8,0.2,1.2
	c-0.3,0.3-0.7,0.6-1.1,0.9c-0.6,0.3-1.2,0.6-1.7,0.9c-0.3,0.1-0.5,0-0.5-0.3L177.7,169.1z M177.6,165.1l-0.1-2.3
	c0-0.1,0.2-0.3,0.3-0.4c0.6-0.1,1.1-0.1,1.7,0c0.2,0,0.4,0,0.6,0.1c0.4,0.1,0.5,0.5,0.2,0.9c-0.2,0.3-0.5,0.6-0.8,0.8
	c-0.5,0.4-1,0.8-1.5,1.1C177.8,165.4,177.6,165.3,177.6,165.1L177.6,165.1z M189.2,162.9l-4.3,5.4c0-1.3-0.8-2.4-2-2.8
	c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0c0.4-0.6,0.7-1.2,0.9-1.9c0.2-0.9,0-1.8-0.4-2.6c-0.4-0.7-1-1.3-1.7-1.6
	c-0.8-0.3-1.6-0.4-2.4-0.4c-0.9,0-1.8,0.1-2.7,0.3l-1.7,0.3c-0.6,0.1-1,0.7-1,1.3l0.4,14.9c0,0.6,0.4,1,1,1c0.1,0,0.1,0,0.2,0
	c0.2,0,0.4-0.1,0.6-0.1c0.6-0.2,1.2-0.3,1.8-0.5s0.9-0.3,1.4-0.5l-5.5,6.9c-0.5,0.7-1.4,0.9-2.1,0.4l-5.6-5.1c0.5,0,1,0,1.6-0.1
	c0.9-0.2,1.8-0.6,2.5-1.2c0.6-0.6,1.2-1.3,1.6-2c0.4-0.8,0.7-1.6,0.9-2.5c0.2-0.9,0.3-1.9,0.3-2.8v-0.5c0.1-0.3-0.1-0.7-0.4-0.8
	c-0.1,0-0.2,0-0.3,0H172l-2.5,0.2l-1.8,0.2c-0.5,0-0.8,0.4-0.8,0.9l-0.1,1.5c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0,0l2-0.2
	c-0.1,0.7-0.4,1.4-0.9,1.9c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.2-0.8,0.2-1.2,0c-0.3-0.1-0.5-0.3-0.6-0.6c-0.2-0.5-0.3-1.1-0.4-1.6
	c0-0.6-0.1-1.3-0.1-1.9c0-0.7,0-1.4,0.1-2.1c0-0.6,0.2-1.1,0.4-1.6c0.2-0.3,0.5-0.6,0.8-0.8c0.4-0.3,0.9-0.4,1.4-0.5
	c0.3,0,0.5,0,0.8,0.1c0.2,0.1,0.4,0.3,0.5,0.5c0.2,0.4,0.3,0.9,0.3,1.4v0.2c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0l2.2-0.5
	c0.4,0,0.6-0.4,0.6-0.8c0-0.4,0-0.9-0.1-1.3c-0.1-0.5-0.2-1.1-0.4-1.6c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.4-0.9-0.8-1.5-1
	c-0.2-0.1-0.4-0.2-0.7-0.2l15.7-2.8c0.4-0.1,0.8,0,1.1,0.3l3.1,3.2C189.7,161.4,189.7,162.3,189.2,162.9z"
  />
</svg>
